import React, { useState } from "react";
import { db, auth } from "../firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "../styles/SupportForm.css";

const SupportForm = () => {
  const [visible, setVisible] = useState(false);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [feedback, setFeedback] = useState("");

  const handleSubmit = async () => {
    if (!subject || !message) {
      alert("Please fill all fields.");
      return;
    }

    const user = auth.currentUser;
    if (!user) return alert("You must be logged in.");

    setSubmitting(true);
    try {
      await addDoc(collection(db, "supportTickets"), {
        uid: user.uid,
        email: user.email,
        subject,
        message,
        status: "open",
        createdAt: serverTimestamp(),
      });

      setFeedback("✅ Your support request has been received. An agent will contact you soon. Thank you!");
      setSubject("");
      setMessage("");
    } catch (err) {
      console.error("Failed to submit ticket:", err);
      alert("❌ Something went wrong.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <button className="btn support-btn" onClick={() => setVisible(true)}>
        💬 Support
      </button>

      {visible && (
        <div className="support-modal">
          <div className="support-card">
            <div className="support-header">
              <h3>Customer Support</h3>
              <button className="close-btn" onClick={() => {
                setVisible(false);
                setFeedback("");
              }}>✖</button>
            </div>

            {feedback ? (
              <div className="success-message">{feedback}</div>
            ) : (
              <>
                <input
                  type="text"
                  placeholder="Subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
                <textarea
                  placeholder="Your message"
                  rows="4"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
                <button onClick={handleSubmit} disabled={submitting}>
                  {submitting ? "Sending..." : "Submit"}
                </button>
              </>
            )}

            <hr />
            <p className="alt-contact">
              Prefer to talk? <br />
              📞 <a href="tel:+2349027161192">Call +2349027161192</a> <br />
              💬 <a href="https://wa.me/2349027161192" target="_blank" rel="noreferrer">
                Chat on WhatsApp
              </a>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default SupportForm;
